import { FormattedRecipe } from '@library/menu-service/queries/menuApiRecipes/types'

export interface CustomisationOption {
  description: string
  option: string
  trackingSlug: string
}

export function getCustomisationForRecipe(
  dietType: FormattedRecipe['attributes']['diet_type'],
): CustomisationOption | null {
  const dietTypeSlug = dietType?.slug

  if (dietTypeSlug === 'vegetarian' || dietTypeSlug === 'vegan') {
    return {
      description:
        'Pack in more protein or stretch dinner even further with juicy chicken breast to poach, grill or roast.',
      option: 'Add chicken breast',
      trackingSlug: 'add_chicken_breast',
    }
  } else if (dietTypeSlug === 'meat' || dietTypeSlug === 'fish') {
    return {
      description:
        'Stretch this meal even further by adding an extra portion of the main protein for this meal.',
      option: 'Double up protein?',
      trackingSlug: 'double_up_protein',
    }
  }

  return null
}
